/*
 * custom-mobile-menu-drawer.js
 *
 * 1. Capture-phase click interceptor trên [data-custom-mmd-swap]:
 *    Khi <768px → ngăn theme handler, mở custom drawer trực tiếp.
 *    Khi ≥768px → để theme handler mở drawer cũ (menu-drawer) như bình thường.
 * 2. Switch tab MENU <-> CATEGORIES.
 * 3. Reset về default tab khi drawer mở.
 */

(function () {
  'use strict';

  const ROOT_SELECTOR = '.custom-mobile-menu-drawer';
  const DIALOG_ID = 'custom-mobile-menu-drawer';
  const MOBILE_BP = 768;

  function isMobileViewport() {
    return window.innerWidth < MOBILE_BP;
  }

  /* ---------------------------------------------------------------
   * Tab switching
   * --------------------------------------------------------------- */
  function setActiveTab(root, tabName) {
    root.querySelectorAll('[data-tab]').forEach((tab) => {
      const isActive = tab.dataset.tab === tabName;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    root.querySelectorAll('[data-panel]').forEach((panel) => {
      const isActive = panel.dataset.panel === tabName;
      panel.classList.toggle('is-active', isActive);
      if (isActive) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });
  }

  function openCustomDrawer() {
    const root = document.querySelector(ROOT_SELECTOR);
    const dialog = document.getElementById(DIALOG_ID);
    if (!dialog) {
      console.warn('[custom-mmd] dialog #' + DIALOG_ID + ' not found in DOM');
      return false;
    }
    const host = dialog.parentElement;
    if (host && typeof host.open === 'function') {
      host.open();
      return true;
    }
    // Fallback: showModal directly
    if (typeof dialog.showModal === 'function') {
      try { dialog.showModal(); return true; } catch (e) { /* noop */ }
    }
    return false;
  }

  function bindRoot(root) {
    if (!root || root.dataset.customMmdBound === '1') return;
    root.dataset.customMmdBound = '1';

    const defaultTab = root.dataset.defaultTab || 'menu';

    // Tab click
    root.addEventListener('click', (e) => {
      const tabBtn = e.target.closest('[data-tab]');
      if (!tabBtn || !root.contains(tabBtn)) return;
      setActiveTab(root, tabBtn.dataset.tab);
    });

    // Reset to default tab when dialog opens
    const dialog = root.querySelector('#' + DIALOG_ID);
    if (dialog) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((m) => {
          if (m.attributeName === 'open' && dialog.hasAttribute('open')) {
            setActiveTab(root, defaultTab);
          }
        });
      });
      observer.observe(dialog, { attributes: true, attributeFilter: ['open'] });
      root._customMmdObserver = observer;
    }
  }

  function unbindRoot(root) {
    if (!root) return;
    if (root._customMmdObserver) {
      root._customMmdObserver.disconnect();
      delete root._customMmdObserver;
    }
    delete root.dataset.customMmdBound;
  }

  function initAll(scope) {
    const ctx = scope || document;
    ctx.querySelectorAll(ROOT_SELECTOR).forEach(bindRoot);
  }

  /* ---------------------------------------------------------------
   * Capture-phase click interceptor
   * Chạy TRƯỚC theme handler (theme handler bubble-phase ở document).
   * --------------------------------------------------------------- */
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-custom-mmd-swap]');
    if (!trigger) return;
    if (!isMobileViewport()) return; // tablet+desktop: cho theme handler chạy như bình thường

    // Mobile: chặn theme handler, mở custom drawer
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    openCustomDrawer();
    trigger.setAttribute('aria-expanded', 'true');
  }, true); // capture: true

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  // Shopify theme editor hooks
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
  document.addEventListener('shopify:section:unload', (e) => {
    e.target.querySelectorAll(ROOT_SELECTOR).forEach(unbindRoot);
  });

  // Khi admin click 1 block trong sidebar → switch tab tương ứng để admin thấy block đang edit.
  // Category block → tab CATEGORIES; các block khác (menu_item / account_link / help_text) → tab MENU.
  document.addEventListener('shopify:block:select', (e) => {
    const block = e.target;
    if (!block) return;
    const root = block.closest(ROOT_SELECTOR);
    if (!root) return;
    const isCategory = block.matches('.custom-mmd__cat-item') || block.closest('.custom-mmd__cat-list');
    setActiveTab(root, isCategory ? 'categories' : 'menu');
  });
})();
